export default "__VITE_ASSET__DqDd9$s3__"